import React from "react";
import { Brands } from "components/Brands";
import { brandsData } from "components/Brands/brandsData";

const DepartmentsComponent = () => {
    return <Brands brands={brandsData} />;
};

export default DepartmentsComponent;
